function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.918 11.6375C14.1313 11.8508 14.3227 12.0859 14.4977 12.3375L14.6727 12.5945L15.4219 10.6695L14.8039 10.3359L12.1461 8.93047L11.3531 10.2812L11.5719 10.3305C12.4469 10.5328 13.2563 10.9867 13.918 11.6375Z",
  fill: "#1442A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2617 12.9937H28.3281H28.3664H28.3773H28.4484H30.2094H30.2367H30.2914H30.3187H31.5766V9.78906H27.2617V12.9937Z",
  fill: "#1442A8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.525 9.39531L28.5195 9.56484H30.1547V7.61797C30.1547 6.06484 29.7609 4.60469 29.0117 3.39609C27.6992 1.24141 25.5172 0.00546875 23.0179 0C20.9125 0 18.8234 0.967969 17.2812 2.65234C15.6297 4.47344 14.3281 6.58984 13.2945 9.12734L13.2398 9.26406L14.782 10.0844L14.8531 9.92031C16.2039 6.76484 17.5984 4.58828 19.1187 3.26484C20.1851 2.32969 21.5523 1.81563 22.9632 1.81563C24.2484 1.81563 25.4515 2.23125 26.4468 3.01328C28.0218 4.24922 28.6617 6.21797 28.525 9.39531Z",
  fill: "#1442A8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2742 25.6375L15.2688 25.6211H15.2414H15.2031C13.0539 25.6375 11.3094 27.3984 11.3094 29.5586C11.3149 31.7242 13.0758 33.4797 15.2414 33.4797C17.407 33.4797 19.168 31.7187 19.168 29.5477C19.1625 27.4039 17.418 25.6375 15.2742 25.6375Z",
  fill: "#1442A8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6594 25.3203V27.218C25.6594 27.4586 25.8562 27.6555 26.0969 27.6555H32.6375C32.8836 27.6555 33.075 27.4641 33.075 27.218V25.3203C33.075 25.0797 32.8781 24.8828 32.6375 24.8828H26.1023C25.8617 24.8773 25.6594 25.0797 25.6594 25.3203Z",
  fill: "#1442A8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4977 13.2125L28.443 24.6586H30.1492V13.2125H28.4977Z",
  fill: "#1442A8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9445 26.3812H33.3047V27.218C33.3047 27.5844 33.0094 27.8797 32.643 27.8797H26.1023C25.7359 27.8797 25.4406 27.5844 25.4406 27.218V26.3812H24.9047C24.3195 26.3812 23.8438 26.857 23.8438 27.4367V29.5969H35V27.4367C35 26.857 34.5242 26.3812 33.9445 26.3812Z",
  fill: "#1442A8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1211 18.7086H0.235181L0.207837 18.8398C0.0765869 19.5016 0.00549316 20.1633 0.00549316 20.7976V20.9617H15.1211V18.7086Z",
  fill: "#1442A8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M14.968 25.4133L15.1211 25.4023V23.6687H0V25.6648C0 27.7484 1.70078 29.4438 3.78437 29.4438H11.0852L11.0961 29.2906C11.2219 27.2125 12.8844 25.5445 14.968 25.4133Z",
  fill: "#1442A8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1211 21.1859H0V23.45H15.1211V21.1859Z",
  fill: "#1442A8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1211 15.0773C15.1211 14.3117 14.9406 13.5844 14.5852 12.9172C14.361 12.4961 14.0821 12.1188 13.7594 11.8016C13.043 11.0852 12.1406 10.6313 11.1617 10.4891C10.943 10.4563 10.7133 10.4398 10.4781 10.4398C5.77502 10.4398 1.5094 13.743 0.333618 18.2875L0.278931 18.4953H15.1211V15.0773ZM12.2719 13.5789C12.9391 13.5789 13.475 14.1203 13.475 14.782C13.475 15.4492 12.9336 15.9852 12.2719 15.9852C11.6047 15.9852 11.0633 15.4438 11.0633 14.782C11.0633 14.1203 11.6047 13.5789 12.2719 13.5789Z",
  fill: "#1442A8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2719 15.7719C12.8133 15.7719 13.2563 15.3289 13.2563 14.7875C13.2563 14.2461 12.8133 13.8031 12.2719 13.8031C11.725 13.8031 11.282 14.2461 11.282 14.7875C11.282 15.3289 11.725 15.7719 12.2719 15.7719Z",
  fill: "#1442A8"
});

var SvgProfessionalCleaning = function SvgProfessionalCleaning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfessionalCleaning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/professional_cleaning.e268330e.svg";
export { ForwardRef as ReactComponent };